module.exports = __webpack_public_path__ + "img/burner-mining-drill-E.9c860044.png";